module.exports = __webpack_public_path__ + "static/media/account_circle_FILL0_wght400_GRAD0_opsz48.101f14b3.svg";